<template>
  <div>

    <!-- 影音搜尋資料區 -->
    <section>
      <div class="ytdwrap" v-bind:class="{ pushdown: plansData.selectedResultShow}" >
        <div v-if="currentDisplayPlans.length === 0">
          <p style="text-align: center;" class="findNothing">無關聯教案，請重新搜尋</p>
        </div>

        <div
          class="clearfix info_item" 
          v-for="plan in currentDisplayPlans"
          :key="plan.id" 
        >
          <router-link :to="'/plan/' + plan.id" >
        
                  <template v-if="plan.badge !== ''" >
                    <div :class="'medal icon' + plan.badge"></div>
                  </template>

                  <div v-if="!plan.validYoutubeLink" class="video-shadow" >
                    <img v-if="plan.imgFileExists" width="400" height="200" :src="require(`@/images/${plan.id}.png`)"/>
                    <img v-else width="400" height="200" src="@/images/img_default.png"/>
                  </div>

                  <div v-else class="video-shadow" >
                    <iframe
                      width="400"
                      height="200"
                      :src="'https://www.youtube.com/embed/' + plan.youtubeLink"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    ></iframe>
                  </div>

                  <div class="textContent" >
                    <h4>適合階段：{{ plan.grade }}</h4>
                    <h3>{{ plan.name }}</h3>
                    <p>科目：{{ plan.subject }}</p>
                    <p v-if="plan.SDGtarget && plan.SDGtarget!==''">目標：{{ plan.SDGtarget.split(',').map(item => item.trim()).join(',&nbsp;&nbsp;') }}</p>
                  </div>
        
          </router-link>
        </div>
      </div>
  
    </section>

    <div class="topup" @click="scrollToTop()"></div>
  </div>
</template>

<script>
import { useDataContext } from '@/composable/plans';

export default {
  name: 'PlansComponent',
  setup() {
    return useDataContext();
  },
  data() {
    return {
      planID: this.$route.params.id,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },

  
  },
  computed: {
    currentDisplayPlans: function () {
      let page = this.plansData.page;
      if (page.currentPage === 0) {
        page.currentPage++;
      }
      let startIndex = (page.currentPage - 1) * page.pageSize;
      let lastIndex = page.currentPage * page.pageSize;
      console.log(this.plansData.filteredPlans.slice(startIndex, lastIndex))
      return this.plansData.filteredPlans.slice(startIndex, lastIndex);
    },
  },

};
</script>

<style scoped>

.findNothing{
  margin-top:20%;
   font-size: 25px;
}

@media screen and (max-width:1024px) {
    .findNothing{
       margin-top:35%;
    }
    
}

@media screen and ( max-width:767px) {   
     .pushdown{
      padding-top:35px;
    }
}
@media screen and (max-width:430px) {
    .findNothing{
       margin-top:20%;
        font-size: 20px;
    }
   .pushdown{
      padding-top:70px;
    }
  
}
</style>
